module.exports = __webpack_public_path__ + "assets/3afb97252c417c5f0dd54e20b1954f63.js";